import { AbstractControl, FormArray } from '@angular/forms';

export function validateMatch(ac: AbstractControl) {
    //validator takes a form array
    const fa = ac as FormArray;
    //array must have 2 form controls
    //checks if those controls match
    return (fa.length === 2) && (fa.at(0)?.value === fa.at(1)?.value) ? null : {
        validateMatch: {
            valid: false
        }
    };
}

